export default "/images/mapping.svg?57a3b2ca5934cb89d6c8b39e979d7e25";